#ifdef GL_ES
precision mediump float;
#endif

#pragma glslify: fbm = require('../partials/fbm.glsl')

uniform float globalOpacity;
varying vec3  vColor;
varying float vAlpha;
varying float vOpacity;
varying float vRandomValue; 


void main() {
    vec2 st = gl_PointCoord - 0.5;
    float dist = length(st);

    if (dist > 0.5) discard;

    float radiusInner = 0.1;
    float radiusOuter = 0.5;

    float baseFade = smoothstep(radiusOuter, radiusInner, dist);

    float noiseFactor = fbm(st * (2.0 + vRandomValue * 0.5), vRandomValue);

    float fade = baseFade * noiseFactor;

    vec4 colorOut = vec4(vColor, vAlpha * vOpacity * globalOpacity * fade);
    gl_FragColor = colorOut;
}
